import { Card } from 'primereact/card';
import { Dialog } from 'primereact/dialog';
import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import BaseDialogContainer from '../baseContainers/BaseDialogContainer';
import { ActionButton } from '../components/ActionButton';
import DivContainer from '../components/DivContainer';
import InputCheckboxComponent from '../components/inputs/InputCheckboxComponent';
import InputDropdownComponent from '../components/inputs/InputDropdownComponent';
import AccountService from '../services/AccountService';
import CardService from '../services/CardService';
import InputTextComponent from '../components/inputs/InputTextComponent';
import AdditionalToolsService from '../services/AdditionalToolsService';
import MotorwayPaymentCardModel from '../model/MotorwayPaymentCardModel';
class CardHighwaysUpdateDialog extends BaseDialogContainer {
    constructor(props) {
        super(props, new CardService());
        this.accountService = new AccountService();
        this.additionalService = new AdditionalToolsService();
        this.state = {
            element: new MotorwayPaymentCardModel(),
            viewMode: this.props.viewMode,
            agreementTermDialog: false,
            highwaysEnabledConst: undefined,
        };
    }

    componentDidUpdate(prevProps, prevState) {
        super.componentDidUpdate(prevProps, prevState);
        if (!prevProps.visible && this.props.visible) {
            this.setElement();
        }
    }

    initBeforeSetElement() { }

    prepareFooter() {
        const { t } = this.props;
        return (
            <div className='footer-dialog-button-container card-manage-footer'>
                <ActionButton
                    label={t('details.cancel')}
                    variant={this.state.viewMode === 'DELETE' ? 'button cancel-button red' : 'button cancel-button white'}
                    handleClick={this.props.onHide}
                />
                <ActionButton
                    label={t('details.saveChanges')}
                    variant='button save-button blue'
                    handleClick={this.handleFormSubmit}
                    rendered={this.state.viewMode !== 'DELETE'}
                />
            </div>
        );
    }

    translate(key) {
        const { t } = this.props;
        return t(key);
    }

    renderHeader() {
        const { t } = this.props;
        return (
            <React.Fragment>
                <DivContainer
                    colClass={'cards-dialog-header'}
                >
                    <DivContainer colClass='col-12'>
                        <label>
                            {`${t('cards.additionalServices') + ''}`}
                        </label>
                    </DivContainer>
                </DivContainer>
            </React.Fragment>
        );
    }

    updateElement(data) {
        this.setState(
            {   highwaysEnabledConst: data.highwayEnabled,
                element: data,
            },
            () => {
                this.initAfterSetElement();
            }
        );
    }

    setElement() {
        if (this.props.element) {
            this.updateElement(this.props.element);
        } else if (this.props.cards && this.props.cards.length >= 1) {
            this.blockUi();
            this.service
                .get(this.props.cards[0])
                .then((res) => {
                    this.updateElement(res);
                    this.unblockUi();
                })
                .catch((err) => {
                    this.showErrorMessage('cards.manageGroupError');
                    this.unblockUi();
                });
        } else {
            this.initAfterSetElement();
        }
    }

    getContainerListName() {
        return 'card-list-container';
    }

    getAddSucces() {
        return 'Osoba kontaktowa została utworzona';
    }

    getUpdateSucces() {
        const { t } = this.props;
        return t('cards.cardsUpdateSuccess');
    }

    createOrUpdate() {
        const { element } = this.state;
        const actionType = element.highwayEnabled === true ? "ACTIVATION" : "DEACTIVATION";
        element.card = this.props.cards;
        if (element.highwayEnabled === false) {
            element.vehicleCategory = undefined;
            element.vehicleRegistration = undefined;
        } else {
            element.vehicleCategory = element.vehicleCategory.id;
        }

        this.scrollToTop();
        if (this.props._isMounted) {
            this.additionalService.highwayCardAction(element)
                .then((response) => {
                    if (response?.result === true) {
                        if (this.props.handleSuccess) {
                            this.props.handleSuccess(response.result);
                        }
                        if (this.props.afterSave) {
                            this.props.afterSave(response);
                        }
                        
                    }
                })
                .catch((err) => {
                    if (this.props.handleError) {
                        this.props.handleError(err, actionType);
                    }
                })
        }
    }


    render() {
        const { className, id, key, name, onHide, visible, style , element} = this.props;
        return (
            <div>
                <Dialog
                    ariaCloseIconLabel={this.translate('dialog.closeDialog')}
                    header={this.renderHeader()}
                    visible={visible && !this.state.agreementTermDialog}
                    className={className}
                    style={style}
                    key={`${key ? key : id ? id : name}-dialog`}
                    onHide={() => (onHide ? onHide() : null)}
                    closable={this.state.closable}
                >
                    {this.state.loading ? null : (
                        <Card footer={this.renderFooter()}>
                            <form onSubmit={this.handleFormSubmit} noValidate onKeyDown={(e) => this.onKeyDown(e)}>
                                {/* {this.renderItems("additionalServices")} */}
                                {this.renderDetails("additionalServices")}
                            </form>
                        </Card>
                    )}
                </Dialog>

            </div>
        );
    }

    vehicleCategoryTemplate(e){
        return "Kategoria " + e.name + " - " + e.description ;
    }
    sortAdditionalServicesDialog(list){
        return list.sort((a, b) => {
            // Jeśli 'a' dotyczy autostrad pryw. to ma być jako pierwszy na liście
            if (a.name === 'HIGHWAYS_PRIVATE') return 1;
            // Jeśli 'b' dotyczy autostrad pryw. to ma być jako pierwszy na liście
            if (b.name === 'HIGHWAYS_PRIVATE') return -1;
            // Jeśli oba elementy nie dotyczą autostrad pryw. to  nie zmieniamy ich kolejności
            return 0;
          });
    }

    renderItems(listName) {
        const {t, element, viewMode} = this.props;
        let allSelected = false;
        let highwayEnabled = this.state.element.highwayEnabled;
        let listSorted = this.sortAdditionalServicesDialog(this.state.element[listName]);
        if (this.state.element[listName] && this.state.element[listName].length) {
            this.state.element[listName].forEach((el) => {
                if (el.name === 'ALL' && el.selected) {
                    allSelected = true;
                    highwayEnabled = true;
                 
                }
            });
        }
        return (
            <div className={'row product-not-fuel-label'}>
                { this.state.element[listName] &&  this.state.element[listName].length
                    ? listSorted.map((p, index) => {
                          const color = p.color ? p.color : 'white';
                          const fontColor = p.color ? 'white' : '#090E22';
                          if(p.name !== "HIGHWAYS_PRIVATE"){
                            return (
                                <InputCheckboxComponent
                                    key={`${p.name}-${listName}`}
                                    id={`${index}-${listName}`}
                                    name='selected'
                                    label={t(`additional-services.${p.name}`)}
                                    labelOnRight
                                    value={p.selected || allSelected}
                                    disabled={allSelected && p.name !== 'ALL'}
                                    validator={this.validator}
                                    onChange={this.handleChange}
                                    viewMode={viewMode}
                                    validators='not_required'
                                    colClass='col-width-auto'
                                    stateField={`element.${listName}[${index}]`}
                                    grayBorder={false}
                                    transparentBorder
                                    labelClassName={`product-label card-details gray-border`}
                                    labelLeftStyle={{
                                        backgroundColor: `${color}`,
                                        color: `${fontColor}`,
                                        padding: '0 4px 0 4px',
                                        marginLeft: '8px',
                                        lineHeight: '24px',
                                        fontSize: '12px',
                                        height: '24px',
                                        marginBottom: 0,
                                    }}
                                />
                            );
                          } else {
                         
                         
                            return ( <div>
                                <InputCheckboxComponent
                                key={`${p.name}-${listName}`}
                                id={`${index}-${listName}`}
                                name='highwayEnabled'
                                label={t(`additional-services.${p.name}`)}
                                labelOnRight
                                value={highwayEnabled || allSelected}
                                disabled={allSelected && p.name !== 'ALL'}
            
                                validator={this.validator}
                                onChange={this.handleChange}
                                viewMode={viewMode}
                                validators='not_required'
                                colClass='col-width-auto'
                                stateField={`element`}
                                grayBorder={false}
                                transparentBorder
                                labelClassName={`product-label card-details gray-border`}
                                labelLeftStyle={{
                                    backgroundColor: `${color}`,
                                    color: `${fontColor}`,
                                    padding: '0 4px 0 4px',
                                    marginLeft: '8px',
                                    lineHeight: '24px',
                                    fontSize: '12px',
                                    height: '24px',
                                    marginBottom: 0,
                                }}
                            /> 
                            
                            <div className='row additional-services motorways'>
                          {/* <div className='row col-12 product-not-fuel-label '>
                              <InputCheckboxComponent
                                  id={`highwayEnabled-id`}
                                  name={'highwayEnabled'}
                                  label={"Autostrady prywatne A1 i A4 Katowice Kraków"}
                                  labelOnRight
                                  value={this.state.element.highwayEnabled }
                                  stateField={`element`}
                                  onChange={this.handleChange}
                                  viewMode={'EDIT'}
                                  validators='not_required'
                                  colClass='col-12'
                              ></InputCheckboxComponent>
                          </div> */}

                          <div className='row highways-enabled-card-fields '>
                              <InputTextComponent
                                  id='registrationNumber'
                                  name='registrationNumber'
                                  label={"Numer rejestracyjny"}
                                  colClass='col-6'
                                  value={element.registrationNumber}
                                  viewMode={'EDIT'}
                                  validator={this.validator}
                                  validators='not_required'
                                  disabled={true}
                                  rendered={this.state.element.highwayEnabled === true}
                              />
                              <InputDropdownComponent
                                  id='vehicleCategory'
                                  name='vehicleCategory'
                                  label={"Kategoria pojazdu"}
                                  colClass='col-6'
                                  value={this.state.element.vehicleCategory}
                                  validator={this.validator}
                                  options={this.props.vehicleCategoryOpt}
                                  onChange={this.handleChange}
                                  viewMode={'EDIT'}
                                  optionLabel='name'
                                  panelClassName={"wrapped-dropdown-panel"}
                                  //optionLabel={this.vehicleCategoryTemplate}
                                  dataKey='name'
                                  validators='required'
                                  stateField='element'
                                  enumMode
                                  rendered={this.state.element.highwayEnabled === true }
                              />
                              {/* {approvals.map((a, index) => { return (<div> a </div>) })} */}
                          </div>

                      </div>
                            </div>
                         
                        )
                            
                          }
                       
                      })
                    : null}

            </div>
        );
    }

    renderDetails(listName) {
        const { t, element } = this.props;
        const activated = true;
        // let allSelected = true;
        // if (this.state.element[listName] && this.state.element[listName].length) {
        //     this.state.element[listName].forEach((el) => {
        //         if (el.name === 'ALL' && el.selected) {
        //             allSelected = true;
        //             highwayEnabled = true;
                 
        //         }
        //     });
        // }
        return (
            <React.Fragment>
                <DivContainer colClass='row'>
                    <Card >
                     
                          <div className='row additional-services motorways'>
                          <div className='row col-12 product-not-fuel-label '>
                              <InputCheckboxComponent
                                  id={`highwayEnabled-id`}
                                  name={'highwayEnabled'}
                                  label={"A1 Toruń-Gdańsk, A2 Konin-Poznań, A4 Kraków-Katowice"}
                                  labelOnRight
                                  value={this.state.element.highwayEnabled }
                                  stateField={`element`}
                                  onChange={this.handleChange}
                                  viewMode={'EDIT'}
                                  validator={this.validator}
                                  validators='required'
                                  colClass='col-12'
                              ></InputCheckboxComponent>
                          </div>
                       
                          <div className='row highways-enabled-card-fields '>
                              <InputTextComponent
                                  id='registrationNumber'
                                  name='registrationNumber'
                                  label={"Numer rejestracyjny"}
                                  colClass='col-6'
                                  value={element.registrationNumber}
                                  viewMode={'EDIT'}
                                  validator={this.validator}
                                  validators='not_required'
                                  disabled={true}
                                  rendered={this.state.element.highwayEnabled === true}
                              />
                              <InputDropdownComponent
                                  id='vehicleCategory'
                                  name='vehicleCategory'
                                  label={"Kategoria pojazdu"}
                                  colClass='col-6 veh-cat'
                                  value={this.state.element.vehicleCategory}
                                  validator={this.validator}
                                  options={this.props.vehicleCategoryOpt}
                                  onChange={this.handleChange}
                                  viewMode={'EDIT'}
                                 // optionLabel='name'                                  
                                  panelClassName={"wrapped-dropdown-panel"}
                                  optionLabel={this.vehicleCategoryTemplate}
                                  dataKey='name'
                                  validators='required'
                                  stateField='element'
                                  enumMode
                                  rendered={this.state.element.highwayEnabled === true }
                              />
                              {/* {approvals.map((a, index) => { return (<div> a </div>) })} */}
                          </div>
                  

                      </div> 
                    </Card>
                    <div className='col-xxl-5 col-xl-4 col-lg-4 col-md-6 col-sm-12'>

                    </div>
                </DivContainer>
            </React.Fragment>
        );
    }
}

CardHighwaysUpdateDialog.defaultProps = {
    currentUser: undefined,
    viewMode: 'VIEW',
    visible: false,
    stationId: undefined,
    vehicleCategoryOpt: undefined
};

CardHighwaysUpdateDialog.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    currentUser: PropTypes.object,
    editUrl: PropTypes.string,
    viewMode: PropTypes.string,
    visible: PropTypes.bool,
    onHide: PropTypes.func,
    afterSave: PropTypes.func,
    stationId: PropTypes.number,
    vehicleCategoryOpt: PropTypes.array,
    handleSuccess: PropTypes.func,
};

export default withTranslation()(CardHighwaysUpdateDialog);
